module.exports = __webpack_public_path__ + "static/stats@2x-2f0b9ed5dee042f85851697f1e388870.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/hudl/stats@2x.jpg
// module id = 383
// module chunks = 3627797113349 20562973939449 33019919093843